<template>
  <footer class="site-footer">
    <div class="container">
      <div class="row container-footer-dropdown text-left">
        <div class="col-sm-12 col-md-6">
          <h6>À propos de nous</h6>
          <p class="text-justify">
            {{ restaurant.observation }}
          </p>
        </div>

        <div class="col-xs-6 col-md-3 custom-footer-responsive">
          <h6>Contactez-nous</h6>
          <ul class="footer-links">
            <li>
              <a href="#"
                ><span class="icon-info-dropdown"
                  ><i class="fas fa-home"></i></span
                >{{ restaurant.address }}</a
              >
            </li>
            <li>
              <a href="#"
                ><span class="icon-info-dropdown"
                  ><i class="fas fa-phone"></i></span
                >{{ restaurant.phone }}</a
              >
            </li>
            <li>
              <a href="#"
                ><span class="icon-info-dropdown"
                  ><i class="fas fa-envelope"></i></span
                >{{ restaurant.email }}</a
              >
            </li>
          </ul>
        </div>

        <div class="col-xs-6 col-md-3 custom-footer-responsive">
          <h6>Horaires</h6>
          <table style="width: 100%;">
            <tr v-for="(hour, index) in restaurant.hours" :key="index">
              <th>
                {{ hour.title }}
              </th>
              <td>{{ hour.value }}</td>
            </tr>
          </table>
        </div>
      </div>
      <hr />
    </div>
    <div class="container">
      <div class="row footer-dropdown-copyright">
        <div class="col-md-4 col-sm-4 col-xs-12">
          <p class="copyright-text">
            Copyright &copy; 2021
            <a href="https://space.monresto.menu" class="link">Monresto.menu</a>
          </p>
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12 text-center">
          <img
            class="logo-bottom-footer-dropdown"
            src="https://space.monresto.menu/icons/Logo@2x.png"
            alt=""
          />
        </div>
        <div class="col-md-4 col-sm-4 col-xs-12 box-socials-icons">
          <ul class="social-icons-dropdown">
            <li>
              <a
                class="facebook"
                :href="`${restaurant.reseau ? restaurant.reseau.facebook : ''}`"
                ><i class="fab fa-facebook"></i
              ></a>
            </li>
            <li>
              <a
                class="instagram"
                :href="
                  `${restaurant.reseau ? restaurant.reseau.instagram : ''}`
                "
                ><i
                  class="fab fa-instagram"
                  style="
    background: no-repeat;
"
                ></i
              ></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  props: ["restaurant", "smaler", "changeName", "currentLang"],

  data() {
    return {};
  },
  methods: {},
  watch: {},
};
</script>
<style>
.logo-bottom-footer-dropdown {
  width: 150px;
}
.box-socials-icons {
  display: flex;
  justify-content: flex-end;
}
.icon-info-dropdown {
  margin-right: 12px;
}
.footer-dropdown-copyright {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.site-footer {
  background-color: #26272b;
  padding: 45px 0 20px;
  font-size: 15px;
  line-height: 24px;
  color: #737373;
}
.site-footer hr {
  border-top-color: #bbb;
  opacity: 0.5;
}
.site-footer hr.small {
  margin: 20px 0;
}
.site-footer h6 {
  color: #fff;
  font-size: 16px;
  text-transform: uppercase;
  margin-top: 5px;
  letter-spacing: 2px;
}
.site-footer a {
  color: #737373;
}
.site-footer a:hover {
  color: #3366cc;
  text-decoration: none;
}
.footer-links {
  padding-left: 0;
  list-style: none;
}
.footer-links li {
  display: block;
  margin-bottom: 5px;
}
.footer-links a {
  color: #737373;
}
.footer-links a:active,
.footer-links a:focus,
.footer-links a:hover {
  color: #3366cc;
  text-decoration: none;
}
.footer-links.inline li {
  display: inline-block;
}
.site-footer .social-icons-dropdown {
  text-align: right;
}
.site-footer .social-icons-dropdown a {
  width: 40px;
  height: 40px;
  line-height: 40px;
  margin-left: 6px;
  margin-right: 0;
  border-radius: 100%;
  background-color: #33353d;
}
.copyright-text {
  margin: 0;
}
@media (max-width: 991px) {
  .site-footer [class^="col-"] {
    margin-bottom: 30px;
  }
}
@media (max-width: 767px) {
  .site-footer {
    padding-bottom: 0;
  }
  .site-footer .copyright-text,
  .site-footer .social-icons-dropdown {
    text-align: center;
  }
}
.social-icons-dropdown {
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.social-icons-dropdown li {
  display: inline-block;
  margin-bottom: 4px;
}
.social-icons-dropdown li.title {
  margin-right: 15px;
  text-transform: uppercase;
  color: #96a2b2;
  font-weight: 700;
  font-size: 13px;
}
.social-icons-dropdown a {
  background-color: #eceeef;
  color: #818a91;
  font-size: 16px;
  display: inline-block;
  line-height: 44px;
  width: 44px;
  height: 44px;
  text-align: center;
  margin-right: 8px;
  border-radius: 100%;
  -webkit-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}
.social-icons-dropdown a:active,
.social-icons-dropdown a:focus,
.social-icons-dropdown a:hover {
  color: #fff;
  background-color: #29aafe;
}
.social-icons-dropdown.size-sm a {
  line-height: 34px;
  height: 34px;
  width: 34px;
  font-size: 14px;
}
.social-icons-dropdown a.facebook:hover {
  background-color: #3b5998;
}
.social-icons-dropdown a.instagram:hover {
  background-color: #ea4c89;
  color: white;
}
.social-icons-dropdown a.linkedin:hover {
  background-color: #007bb6;
}
.social-icons-dropdown a.dribbble:hover {
  background-color: #ea4c89;
}
@media (max-width: 767px) {
  .social-icons-dropdown li.title {
    display: block;
    margin-right: 0;
    font-weight: 600;
  }

  .custom-footer-responsive {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .box-socials-icons {
    justify-content: center;
  }
  table tr th {
    max-width: 36px !important;
  }
  .container-footer-dropdown {
    margin: 0;
    padding: 0;
    width: 100%;
  }
  .footer-dropdown-copyright {
    width: 100%;
    margin: 0;
    padding: 0;
  }
}
</style>
